<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
      <template #action>
        <div class="main">
          <!-- 検索 -->
          <div class="flex flex-wrap mb-5">
            <div class="flex rounded text-center p-2 border border-blue-500 font-bold mt-5">
              <div class="mr-3">
                <input type="checkbox" id="incomplete" v-model="filter.incomplete" @change="getData()">
                <label for="incomplete" class="p-1">未完了</label>
              </div>
              <div>
                <input type="checkbox" id="complete" v-model="filter.complete" @change="getData()">
                <label for="complete" class="p-1">完了</label>
              </div>
            </div>

            <!-- 巡回の種類 -->
            <div>
              <div class="flex">
                <div @click="all(true)" class="text-sm font-bold text-blue-700 cursor-pointer px-3">全選択</div>
                <div @click="all(false)" class="text-sm font-bold text-blue-700 cursor-pointer px-3">全解除</div>
              </div>

              <div class="flex rounded text-center p-2 border border-blue-500 ml-3">
                <div>
                  <input type="checkbox" id="1" v-model="filter.type1" @change="getData()">
                  <label for="1" class="p-1 text-blue-700 font-bold">品管</label>
                </div>
                <div class="mx-2">
                  <input type="checkbox" id="2" v-model="filter.type2" @change="getData()" :class="filter.type2?'bg-pink-700':''">
                  <label for="2" class="p-1 text-pink-700 font-bold">巡回</label>
                </div>
                <div>
                  <input type="checkbox" id="3" v-model="filter.type3" @change="getData()" :class="filter.type3?'bg-yellow-700':''">
                  <label for="3" class="p-1 text-yellow-700 font-bold">定期</label>
                </div>
                <div class="mx-2">
                  <input type="checkbox" id="4" v-model="filter.type4" @change="getData()" :class="filter.type4?'bg-purple-700':''">
                  <label for="4" class="p-1 text-purple-700 font-bold">設備</label>
                </div>
                <div>
                  <input type="checkbox" id="7" v-model="filter.type7" @change="getData()" :class="filter.type7?'bg-green-700':''">
                  <label for="7" class="p-1 text-green-700 font-bold">同行</label>
                </div>
              </div>
            </div>

            <!-- 自分の分のみ -->
            <PrimaryButton
              v-tooltip="'自分のデータのみ'"
              :text="isMobileDevice||isTabletDevice?'自分のデータ':''"
              :buttonContents="'要'"
              class="ml-3 mt-5"
              :class="[filter.userIcon ? 'clickButtonColor2' : 'normalButtonColor', isMobileDevice||isTabletDevice?'px-1':'']"
              @click="clickUserIcon()"
            >
              <Icon v-if="!isMobileDevice&&!isTabletDevice" slot="before" iconName="User" iconType="solid" :strokeWidth="2" class="h-5 w-5 " />
            </PrimaryButton>

            <!-- 担当者検索 -->
            <input
              type="search"
              placeholder="担当者 検索"
              class="ml-3 py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 mt-5" 
              v-model="filter.staff"
            />

            <!-- 物件名検索 -->
            <input
              type="search"
              placeholder="物件名 検索"
              class="ml-3 py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900 mt-5" 
              v-model="filter.site"
            />

            <!-- 検索 -->
            <PrimaryButton
              text="検索"
              :buttonContents="'要'"
              class="ml-auto mt-5"
              :disabled="loading"
              @click="getData()"
            >
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4 my-auto mr-2 text-white" />
            </PrimaryButton>

            <!-- 閉じる -->
            <SecondaryButton
              text="閉じる"
              class="ml-8 mt-5 w-fit block mr-1"
              @click="closed()"
            ></SecondaryButton>
          </div>

          <full-calendar
            ref="calendar"
            id="calendar"
            :events="events"
            :config="config"
            @view-render="viewRender"
            @event-selected="eventSelected"
            @event-drop="eventDrop"
            @event-resize="eventResize"
          ></full-calendar>

        </div>
      </template>
    </Modal>
    <!-- 詳細モーダル -->
    <CalendarDetailModal
      v-model="openModal"
      :open="openModal"
      :target="target"
      :staffList="staffList"
      :gpsDiff="gpsDiff"
      @getData="getData()"
      @closed="openModal=false"
    />
  </div>
</template>
<script>
import Icon from '@components/Icon.vue'
import Modal from '@components/Modal.vue'
import { FullCalendar } from 'vue-full-calendar'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import CalendarDetailModal from '../components/CalendarDetailModal.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import * as backend from '@libs/backend'
import 'fullcalendar/dist/fullcalendar.css'
import * as utils from '@libs/utils'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'

export default {
  components: {
    FullCalendar,
    Icon,
    Modal,
    CalendarDetailModal,
    PrimaryButton,
    SecondaryButton,
    LoadingIcon
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    gpsDiff: {
      type: Number
    }
  },

  data() {
    return {
      loading: false,
      // 検索
      filter: {
        incomplete: true,
        complete: false,
        type1: true,
        type2: true,
        type3: true,
        type4: true,
        type7: true,
        userIcon: true,
        staff: null,
        site:null
      },
      // モダール開閉
      openModal: false,
      // モーダルに渡すデータ
      target: {},
      // モーダルに渡す担当者リスト
      staffList: [],
      // 表示開始日
      start: null,
      // 表示終了日
      end: null,
      // 表示データ
      events: [],
      // 設定
      config: {
        // 初期表示：月間
        defaultView: 'month',
        // 日本語
        locale: 'ja',
      },
    }
  },

  computed: {
    /**
     * ログインユーザー名（カナなし、スペースなし）
     */
    userName() {
      return utils.deleteSpace(utils.deleteKana(this.$store.getters.user.user_name))
    },

    userId() {
      return this.$store.getters.user.id
    },

    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タブレット
     */
    isTabletDevice() {
      return utils.deviceInfo.isTablet
    },
  },

  watch: {
    async open() {
      if (this.open) {
        await this.getData()
        // スタッフリスト取得
        if (!this.staffList || !this.staffList.length) {
          const res = await backend.searchData('patrolStaff/get', {})
          if (res.data.data) {
            this.staffList = res.data.data
          } else {
            this.staffList = []
          }
        }
      }
    },
  },

  async created() {
  },

  methods: {
    /**
     * カレンダーデータ取得
     */
    async getData() {
      if (!this.open) {
        return
      }
      if (!this.filter.type1 && !this.filter.type2 && !this.filter.type3 && !this.filter.type4 && !this.filter.type7) {
        this.events = []
        return
      }
      this.loading = true
      if (this.start && this.end) {
        const res = await backend.postData('patrolSchedule/getCalendarList', { start: this.start, end: this.end, ...this.filter, userId: this.userId })
        if (res.data.data) {
          this.events = res.data.data
        } else {
          this.events = []
        }
      }
      this.loading = false
    },

    /**
     * 全選択、全解除
     */
    all(val) {
      this.filter.type1 = val
      this.filter.type2 = val
      this.filter.type3 = val
      this.filter.type4 = val
      this.filter.type7 = val
      this.getData()
    },

    /**
     * 自分の予定を検索変更
     */
    clickUserIcon() {
      this.filter.userIcon = !this.filter.userIcon
      this.getData()
    },

    /**
     * 月、週、日の切替
     */
    viewRender(v) {
      const start = moment(v.start).format('YYYY-MM-DD')
      const end = moment(v.end).format('YYYY-MM-DD')

      this.start = start
      this.end = end
      this.getData()
    },

    /**
     * クリック
     */
    eventSelected(e) {
      // ダイアログopen
      this.target = e
      this.openModal = true
    },

    /**
     * ドロップ
     */
    async eventDrop(e) {
      // 日付が変わっていないなら何もしない
      if (e.scDate == moment(e.start).format('YYYY-MM-DD')) {
        return
      }
      // 本日より前の日付だったらNG
      const today = Number(moment().format('YYYYMMDD'))
      const target = Number(moment(e.start).format('YYYYMMDD'))
      if (today > target) {
        await dialogs.showErrorDialog('過去日のため変更不可', '本日以降にしてください。')
        this.getData()
        return
      }

      // 定期清掃の場合
      if (e.type == 3) {
        const res = await backend.searchData('patrolSchedule/getFixedSchedule', { id: e.id })
        // 連日作業がある場合
        if (res.data.data && res.data.data.length > 1) {
          this.target = e
          this.openModal = true
        // 連日作業がない場合
        } else {
          const log = await dialogs.showConfirmDialog('保存しますか？', '※定期清掃は予定変更した場合、メインタスクを自動登録します。\r\n予定を変更保存してよろしいですか？')
          if (log != 'YES') {
            this.getData()
            return
          }
          await this.saveData(e)
          // メインタスク登録
          const val = {
            siteName: e.siteName,
            before: e.scDate,
            after: moment(e.start).format('YYYY-MM-DD'),
            user: this.$store.getters.user,
            userDepartment: this.$store.getters.userDepartment,
            limitDate: moment(e.start).add(-1, 'days').format('YYYY-MM-DD')
          }
          await utils.mainForChangeFixed(val, this)
        }
      // 定期清掃以外
      } else {
        const log = await dialogs.showConfirmDialog('保存しますか？', '予定を変更保存してよろしいですか？')
        if (log != 'YES') {
          this.getData()
          return
        }
        await this.saveData(e)
      }
    },

    /**
     * データ保存
     */
    async saveData(e) {
      const scheduledDate = moment(e.start).format('YYYY-MM-DD HH:mm:ss')
      const insertUser = this.$store.getters.user.id
      const insertName = this.$store.getters.user.user_name

      // 巡回参照エラーが出るため、保存するデータを成型
      const saveData = {
        id: e.id,
        type: e.type,
        scheduledDate: scheduledDate,
        userName: e.userName,
        userId: e.userId,
        patrolNumber: e.patrolNumber,
        insertUser,
        eventDrop: true,
        insertName,
        siteName: e.siteName
      }
      
      await backend.postData('patrolSchedule/upDateByCalendarModal', saveData)
      this.getData()
    },

    /**
     * サイズ変更
     */
    eventResize() {
      alert('この機能は無効です')
      this.getData()
    },

    /**
     * 再描画
     */
    refreshEvents() {
      this.$refs.calendar.$emit('refetch-events')
    },

    /**
     * 初期化
     */
    closed() {
      this.loading = false
      // モダール開閉
      this.openModal = false
      // モーダルに渡すデータ
      this.target = {}
      // 表示データ
      this.events = []
      this.$emit('closed')
    },
  }
}
</script>
<style scoped>
/* .main {
  min-width: 1320px;
} */

#calendar >>> table > thead > tr > td > .fc-row {
  margin-right: 0px !important;
}

#calendar >>> table > tbody > tr > .fc-widget-content > .fc-scroller {
  height: 100% !important;
  overflow: hidden !important;
}
</style>